import { Modal } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const ScheduleUpdateConfirmModalContainer = styled(Modal)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    width: 800px;

    .ant-modal-content {
      padding-inline: 0;
    }

    .ant-modal-header {
      margin: 0;
      padding-bottom: ${kcc.size.S250}px;
      padding-inline: ${kcc.size.S250}px;
      font-size: ${kcc.typography.FONT_SIZE.HEADING_4}px;
      line-height: 24px;

      .ant-btn {
        width: ${kcc.size.S300}px;
        height: ${kcc.size.S300}px;
        padding: 0;
      }

      svg {
        width: ${kcc.size.S300}px;
        height: ${kcc.size.S300}px;
      }
    }

    .ant-modal-body {
      padding-block: ${kcc.size.S50}px; // to avoid losing outline
      padding-inline: ${kcc.size.S250}px;
    }

    .ant-modal-footer {
      margin: 0;
      padding-inline: ${kcc.size.S250}px;
      padding-top: ${kcc.size.S250}px;
    }
  `}
`;

export const IconContainer = styled.div`
  width: ${({ theme: { kcc } }): number => kcc.size.S300}px;
  height: ${({ theme: { kcc } }): number => kcc.size.S300}px;

  svg {
    path {
      fill: ${({ theme: { kcc } }): string => kcc.colors.BLACK};
    }
  }
`;

export const UpdateScopeOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { kcc } }): string => kcc.spacing.MD};
  margin-top: ${({ theme: { kcc } }): string => kcc.spacing.MD};
`;
